// extracted by mini-css-extract-plugin
export default {"primaryColor":"#004c95","primaryColorWithAlpha":"rgba(63,113,175,.1529411765)","mainBgColor":"#f1f1f1","secondBgColor":"#fff","menuTextColor":"#29292c"};